/* eslint-disable */

'use strict';
import includes from 'lodash/includes';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingMode} from '../../core-components/loading-icon/utils';
import {logger} from './logger';


module.exports = [
  '$filter',
  'BaseFilterMixin',
  '$exceptionHandler',
  PersonnelFilterMixin];

function PersonnelFilterMixin(
  $filter,
  BaseFilterMixin,
  $exceptionHandler,
) {
  return PersonnelFilter;
  /**
   *
   * @param {$rootScope.Scope} $scope
   * @param {Object} [vm]
   * @param {boolean} [vm.showNonUsers=true]
   * @param {string} [cacheId]
   * @returns {{size: (*|size), updateLimit: (*|updateRenderLimit), initFiltering: initFiltering, destroyFiltering: (*|destroyFiltering)}}
   * @constructor
   */
  function PersonnelFilter($scope, filterScope, vm, cacheId) {
    const baseFilter = new BaseFilterMixin($scope, {
      vm: vm,
      filterVm: filterScope,
      filterScope: filterScope,
      initialFilter: vm.filter || null,
      cacheId: cacheId,
      filterTemplate: '',
      defaultSortProperty: 'name',
      filterOptions: {},
      enablePagination: true,
      pageSize: 15
    });

    return {
      size: baseFilter.size,
      updateLimit: baseFilter.updateRenderLimit,
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering
    };

    function initFiltering(personnel$) {
      baseFilter.registerFilter('filteredPersonnelList');

      // convert the task list into an observable
      /**
       *
       * @type {Observable<Array>}
       */
      const sorted$ = personnel$
        .switchMap(loadPersonnel)
        .map(sortPersonnel)
        .catch(epicErrorHandler(logger, 'sorted$'));

      const filtered$ = Observable.combineLatest(
        sorted$,
        baseFilter.filterObservable,
        filterPersonnel)
        .catch(epicErrorHandler(logger, 'filtered$'));

      baseFilter.activeSubscriptions.push(updateLoadingMode(sorted$, $scope, vm));

      baseFilter.activeSubscriptions.push(baseFilter.filterObservable.subscribe(updateFilter));

      baseFilter.activeSubscriptions.push(filtered$.subscribe(baseFilter.updateFilter('filteredPersonnelList', $scope)));
    }

    function updateFilter(filter) {
      $scope.$safeApply(function () {
        vm.filter = filter;
      })
    }

    function loadPersonnel(personnel) {
      var list = [];

      for (var key in personnel) {
        if (personnel.hasOwnProperty(key) && isObject(personnel[key])) {
          list.push(loadPerson(personnel[key]));
        } else if (process.env.DEBUG_MODE && personnel.hasOwnProperty(key) && !isObject(personnel[key])) {
          console.warn(`Corrupt person data found with ID "${key}"`);
        }
      }

      return Promise.all(list);
    }

    function loadPerson(person) {
      if (person && isFunction(person.$loaded)) {
        return person.$loaded().then(function () {
          return person;
        });
      } else {
        console.warn('Called loadPerson with invalid instance:', person);
        return Promise.resolve(person);
      }
    }

    /**
     *
     * @param {Array} personnel
     * @return {Array}
     */
    function sortPersonnel(personnel) {
      return personnel.sort($filter.$sortByPropertyAccessor(getToString, $filter.SORT_METHODS.ASCENDING.val, true));
    }

    function filterPersonnel(list, query) {
      if (vm.showNonUsers && (!query || typeof query !== 'string')) return list;

      var item, i, length, result = [];
      if (typeof query === 'string') query = query.toLowerCase();

      for (i = 0, length = list.length; i < length; i++) {
        item = list[i];

        if (query) {
          if (matchesPerson(item, query)) {
            if (!vm.showNonUsers && !item.aliasFor) continue;
            result.push(item);
          } else if (item.aliasFor && matchesPerson(item.aliasFor, query)) {
            if (!vm.showNonUsers && !item.aliasFor) continue;
            result.push(item);
          }
        } else {
          if (!vm.showNonUsers && !item.aliasFor) continue;
          result.push(item);
        }
      }

      return result;
    }
  }

  function matchesPerson(item, query) {
    var itemProperty;
    var matching = false;
    if (item && isObject(item)) {
      if (includes(item.toString().toLowerCase(), query)) {
        matching = true;
      } else if (isString(item.role) && includes(item.role.toLowerCase(), query)) {
        matching = true;
      }
    }
    return matching;
  }

  function getToString(person) {
    return person ? person.toString() : '';
  }

  function delegateListError(error) {
    $exceptionHandler(error, 'PersonnelFilterMixin.feed: error occurred while updating list contents');
  }

  function delegateFilterError(error) {
    $exceptionHandler(error, 'PersonnelFilterMixin.feed: error occurred while updating filter');
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/filters/PersonnelFilterMixin.js